module.exports = __webpack_public_path__ + "img/buy-sell.d56b70b5.jpg";